const to_display_time = (val: number) => {
  const hour = Math.floor(val / 3600)
  let hour_str
  if (hour < 10) {
    hour_str = `0${hour}`
  } else {
    hour_str = String(hour)
  }

  const minute = Math.floor((val - (hour * 3600)) / 60)
  let minute_str
  if (minute < 10) {
    minute_str = `0${minute}`
  } else {
    minute_str = String(minute)
  }
  return `${hour_str}:${minute_str}`
}

export const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  plotOptions: {
    bar: {
      columnWidth: '55%',
    },
  },
  stroke: {
    width: [0, 4],
  },
  legend: {
    position: 'top',
  },
  xaxis: {
    type: 'category',
    categories: [0],
    labels: {
      style: {
        colors: [""],
      },
    },
  },
  colors: ["#094E8D", "#46A0F8"],
  markers: {
    size: 6,
    colors: "#FFFFFF",
    strokeColors: "#46A0F8",
    strokeWidth: 2,
    hover: {
      size: 7,
    },
  },
  yaxis: [
    {
      labels: {
        formatter: (val: number): string => to_display_time(val),
      },
    },
    {
      opposite: true,
      labels: {
        formatter: (val: number): string => `${val}biz`,
      },
    },
  ],
}

export default chartOptions
